import { render, staticRenderFns } from "./NotificationModalContent.vue?vue&type=template&id=5c8148e0&scoped=true"
import script from "./NotificationModalContent.vue?vue&type=script&lang=ts"
export * from "./NotificationModalContent.vue?vue&type=script&lang=ts"
import style0 from "./NotificationModalContent.vue?vue&type=style&index=0&id=5c8148e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8148e0",
  null
  
)

export default component.exports